'use strict';

(function (angular, $) {
    StoreFinderController.$inject = ['$scope', '$location', '$window', '$document', 'locationService', 'storeService', 'MAPSETTINGS', 'PROMOTIONS', 'SELECTEDPROMOS', 'SERVICES', 'ICONS', 'CLUSTERIMAGEURL', 'TEXTS', 'IS_GOOGLE_AVAILABLE'];
    angular
        .module('jwsdw.storeFinder')
        .config(['$locationProvider', function($locationProvider) {
            $locationProvider.html5Mode(true);
            // $locationProvider.hashPrefix('?');
        }])
        .controller('StoreFinderController', StoreFinderController);

    /**
     * @class jwsdwStoreFinder.StoreFinderController
     * @description Initializes the StoreFinderController
     * @param {Object} $scope current scope
     * @param {Object} $location browser location object
     * @param {Object} $window browser window object
     * @param {Object} $document browser document object
     * @param {Object} locationService service providing location functions
     * @param {Object} storeService service for stores
     * @param {Object} MAPSETTINGS settings for initializing google mas
     * @param {Object} PROMOTIONS active store promotions
     * @param {Object} SELECTEDPROMOS preselected store promotions
     * @param {Object} SERVICES active store services
     * @param {Object} ICONS contains marker icons
     * @param {Object} CLUSTERIMAGEURL cluster marker image
     * @param {Object} TEXTS localized texts
     * @param {Boolean} IS_GOOGLE_AVAILABLE true if google maps was loaded successfully (provided though jwsdwSettings)
     * @constructor
     */
    function StoreFinderController($scope, $location, $window, $document, locationService, storeService, MAPSETTINGS, PROMOTIONS, SELECTEDPROMOS, SERVICES, ICONS, CLUSTERIMAGEURL, TEXTS, IS_GOOGLE_AVAILABLE) { // eslint-disable-line
        var vm = this,
            $map = document.getElementById('jwsdw-map'),
            gmap,
            markers = [],
            _ready = false,
            _filter = $location.search().filter ? $location.search().filter.split(',') : [],
            _stores = [],
            _promoServices = PROMOTIONS.concat(SERVICES);

        vm.mapView = true;
        vm.stores = [];
        vm.selectedStore = null;
        vm.searchQuery = '';
        vm.searchLoading = false;
        vm.searchByAddress = searchByAddress;
        vm.locatePosition = locatePosition;
        vm.onSearchSubmit = onSearchSubmit;
        vm.selectStore = selectStore;
        vm.highlightStore = highlightStore;
        vm.error = null;
        vm.locationError = locationService.error;
        vm.viewport = '';
        vm.service = $location.search().service;
        vm.selectedPromos = SELECTEDPROMOS ? SELECTEDPROMOS : [];
        vm.random = function() {
            return Math.round((new Date()).getTime() / 1000);
        };

        // hide unrelated promotions without a picture on the general storeFinder
        vm.promotions = PROMOTIONS.filter(function(promotion) {
            return promotion.picture || vm.selectedPromos.indexOf(promotion.id) !== -1;
        });

        vm.services = SERVICES;
        vm.filter = {};
        _filter.forEach(function(filter) {
            vm.filter[filter] = true;
        });

        vm.filterCount = 0;
        vm.openFilterPicker = openFilterPicker;
        vm.filterHasResults = filterHasResults;
        vm.canBeFiltered = canBeFiltered;
        vm.applyFilters = applyFilters;

        $scope.filter = vm.filter;

        /**
         * @description activate function
         * @returns {void}
         */
        this.$onInit = function () {
            vm.searchQuery = $location.search().location;

            $window.jwsdwMediator.publish('updateBreadcrumbs', [
                {
                    'text': TEXTS.title,
                    'url': $window.location.pathname
                }
            ]);

            // activate google maps functionalities
            if (!IS_GOOGLE_AVAILABLE) {
                $window.jwsdwMediator.subscribe('activateGoogleMaps', function() {
                    activateMaps();
                });
            } else {
                activateMaps();
            }

            vm.filterCount = _filter.filter(function(filter) {
                return !/noJWStores|noRetailers|noOutlets/.test(filter);
            }).length;

            _filter.forEach(function(f) {
                vm.filter[f] = true;
            });

            $window.jwsdwMediator.subscribe('closeStoreCard', function() {
                selectStore(null);
                vm.selectedStore = null;
            });
        };

        /**
         * @description Method to initialize google maps
         * @returns {void}
         */
        function activateMaps() {
            var defaultLocation = new $window.google.maps.LatLng(MAPSETTINGS.lat, MAPSETTINGS.lng),
                mapOptions = {
                    'center': defaultLocation,
                    'zoom': MAPSETTINGS.zoom,
                    'maxZoom': 18,
                    'minZoom': 5,
                    'mapTypeId': $window.google.maps.MapTypeId.ROADMAP,
                    'draggable': true,
                    'disableDefaultUI': true,
                    'streetViewControl': false,
                    'mapTypeControl': false,
                    'zoomControl': /large/.test(vm.viewport)
                };

            gmap = new $window.google.maps.Map($document[0].getElementById('jwsdw-map'), mapOptions);

            $window.google.maps.event.addDomListener($window, 'load', function() {
                var participatingStores;

                _ready = true;

                if (vm.searchQuery) {
                    searchByAddress(vm.searchQuery);
                }
                if (vm.selectedPromos.length > 0 && !vm.searchQuery) {
                    // presearch stores when preselected promotions are set
                    participatingStores = vm.promotions.concat(vm.services).reduce(function(promoStores, promo) {
                        if (vm.selectedPromos.indexOf(promo.id) === -1) {
                            return promoStores;
                        }
                        return promoStores.concat(promo.participatingStores);
                    }, []);
                    getStores(participatingStores);
                }
            });

            $window.google.maps.event.addDomListener($window, 'resize', function() {
                if (gmap) {
                    gmap.setOptions({
                        'zoomControl': /large/.test(vm.viewport)
                    });
                    resizeMap();
                }
            });
        }

        /**
         * @description Method to search stores by address
         * @param {String} searchQuery search query
         * @returns {void}
         */
        function searchByAddress(searchQuery) {
            if (!_ready || searchQuery === '') {
                return;
            }

            document.activeElement.blur();

            vm.searchLoading = true;
            vm.positionLocated = false;
            vm.stores = [];

            $location.search('location', searchQuery);

            $window.jwsdwMediator.publish('updateBreadcrumbs', [
                {
                    'text': TEXTS.title,
                    'url': $window.location.pathname
                },
                {
                    'text': searchQuery,
                    'url': $window.location.pathname + '/?location=' + searchQuery
                }
            ]);

            clearMarkers();

            storeService
                .searchByAddress(searchQuery)
                .then(searchSuccess, searchError);

            /**
             * @description Method called on success
             * @param {Object} response response object
             * @param {Object} response.stores stores container
             * @param {Object[]} response.stores.stores array of stores
             * @param {Object} response.stores.myStore myStore object
             * @param {Object} response.position coordinates container
             * @param {Number} response.position.lat latitude
             * @param {Number} response.position.lng longitude
             * @returns {void}
             */
            function searchSuccess(response) {
                vm.searchLoading = false;
                vm.selectedStore = null;

                if (!response) {
                    return searchError();
                }
                _stores = response.stores.stores;

                if (response.stores.myStore) {
                    response.stores.myStore.myStore = true;
                    _stores.unshift(response.stores.myStore);
                }
                gmap.setCenter(response.position);
                gmap.setZoom(11);

                _centerViewportOnMap();

                renderStores(_stores);

                window.dataLayer.push({
                    'event': 'ce.misc',
                    'eventCategory': 'Misc',
                    'eventAction': 'Storefinder',
                    'eventLabel': searchQuery,
                    'eventValue': undefined,
                    'nonInteraction': false,
                    'searchResults': response.stores.stores.length
                });
            }

            /**
             * @description Method called on error
             * @returns {void}
             */
            function searchError() {
                vm.searchLoading = false;
                vm.stores = [];
                vm.selectedStore = null;
                vm.error = 'SEARCH_ERROR';
                setTimeout(resizeMap, 200); // resize map after CSS animation
            }
        }

        /**
         * @description Method to search stores by coordinates
         * @param {Number} lat Latitude of current position
         * @param {Number} lng Longitude of current position
         * @returns {void}
         */
        function searchByLocation(lat, lng) {
            if (!_ready || !lat || !lng) {
                return;
            }

            window.dataLayer.push({
                'event': 'ce.misc',
                'eventCategory': 'Misc',
                'eventAction': 'Storefinder',
                'eventLabel': lat + '-' + lng,
                'eventValue': undefined,
                'nonInteraction': false,
                'searchResults': '300'
            });

            document.activeElement.blur();

            vm.searchLoading = true;
            vm.stores = [];

            $window.jwsdwMediator.publish('updateBreadcrumbs', [
                {
                    'text': TEXTS.title,
                    'url': $window.location.pathname
                }
            ]);

            clearMarkers();

            storeService
                .searchByLocation(lat, lng)
                .then(searchSuccess, searchError);

            /**
             * @description Method called on success
             * @param {Object} response response object
             * @param {Object} response.stores stores container
             * @param {Object[]} response.stores.stores array of stores
             * @param {Object} response.stores.myStore myStore object
             * @param {Object} response.position coordinates container
             * @param {Number} response.position.lat latitude
             * @param {Number} response.position.lng longitude
             * @returns {void}
             */
            function searchSuccess(response) {
                vm.searchLoading = false;
                _stores = response.stores.stores;

                if (response.stores.myStore) {
                    response.stores.myStore.myStore = true;
                    _stores.unshift(response.stores.myStore);
                }
                gmap.setCenter(response.position);
                gmap.setZoom(9);

                _centerViewportOnMap();

                renderStores(_stores);
            }

            /**
             * @description Method called on error
             * @returns {void}
             */
            function searchError() {
                vm.searchLoading = false;
                vm.stores = [];
                vm.error = 'SEARCH_ERROR';
                setTimeout(resizeMap, 200); // resize map after CSS animation
            }
        }

        /**
         * @param {String[]} storeIds array of store Ids
         * @returns {void}
         */
        function getStores(storeIds) {
            if (!_ready || !storeIds || storeIds.length === 0) {
                return;
            }

            document.activeElement.blur();

            vm.searchLoading = true;
            vm.stores = [];

            clearMarkers();

            storeService
                .getStores(storeIds, $window.jwsdwSettings.countryCode)
                .then(searchSuccess, searchError);

            /**
             * @description Method called on success
             * @param {Object} response response object
             * @param {Object[]} response.stores array of stores
             * @param {Object} response.myStore myStore object
             * @returns {void}
             */
            function searchSuccess(response) {
                vm.searchLoading = false;
                _stores = response.stores;
                if (response.myStore) {
                    response.myStore.myStore = true;
                    _stores.unshift(response.myStore);
                }

                gmap.setCenter(_getCenter(_stores));
                gmap.setZoom(7);

                _centerViewportOnMap();

                renderStores(_stores);
            }

            /**
             * @description Method called on error
             * @returns {void}
             */
            function searchError() {
                vm.searchLoading = false;
                vm.stores = [];
                vm.error = 'SEARCH_ERROR';
                setTimeout(resizeMap, 200); // resize map after CSS animation
            }
        }


        /**
         * @description Method to locate user's position and perform search
         * @returns {void}
         */
        function locatePosition() {
            vm.stores = [];
            vm.positionLocated = true;

            locationService.geolocateAdress().then(locateSuccess, locateError);

            /**
             * @description Method called on success
             * @param {Object} position position object
             * @param {Number} position.lat latitude
             * @param {Number} position.lng longitude
             * @returns {void}
             */
            function locateSuccess(position) {
                clearFilters(false);
                searchByLocation(position.lat, position.lng);
            }

            /**
             * @description Method called on error
             * @param {String} err location error message
             * @returns {void}
             */
            function locateError(err) {
                vm.error = err;
                vm.stores = [];
                setTimeout(resizeMap, 200); // resize map after CSS animation
            }
        }

        /**
         * @description Method to perform search on form submit
         * @param {String} searchQuery searchQuery
         * @returns {void}
         */
        function onSearchSubmit(searchQuery) {
            clearFilters();
            searchByAddress(searchQuery);
        }

        /**
         * @description Method to render stores
         * @param {Object[]} stores array of stores
         * @param {String} stores[].id store id
         * @param {Number} stores[].lat latitude
         * @param {Number} stores[].lng longitude
         * @param {String} stores[].storeType store type
         * @returns {void}
         */
        function renderStores(stores) {
            if (stores && stores.length > 0) {
                vm.stores = vm.stores.map(function(store) {
                    store.storeType = storeService.getStoreType(store);
                    return store;
                });
                vm.stores = _filterStores(stores, vm.filter).sort(sortStores);

                vm.stores.forEach(function(store) {
                    store && renderGoogleMapMarker(store);
                });
                if (vm.selectedPromos.length > 0) {
                    consolidateMarkers();
                }
                if (vm.stores.length === 0) {
                    vm.error = 'NO_PARTICIPATING_STORES';
                } else {
                    vm.error = null;
                }
            } else {
                vm.error = 'SEARCH_ERROR';
            }

            setTimeout(resizeMap, 200); // resize map after CSS animation
        }

        /**
         * @description Method to cluster markers
         * @returns {void}
         */
        function consolidateMarkers() {
            new MarkerClusterer(gmap, markers, { // eslint-disable-line
                'minimumClusterSize': 5,
                'styles': [
                    {
                        'url': CLUSTERIMAGEURL,
                        'width': 30,
                        'height': 39,
                        'anchorText': [-5, 0]
                    }
                ]
            });
        }

        /**
         * @description Method to sort stores by store type - JW Store first
         * @param {Object} a store A
         * @param {Object} b store B
         * @returns {Number} 1, 0, -1
         */
        function sortStores(a, b) {
            if (/OwnStore|Franchise|Outlet/i.test(a.storeType) && !/OwnStore|Franchise|Outlet/i.test(b.storeType)) {
                return -1;
            } else if (!/OwnStore|Franchise|Outlet/i.test(a.storeType) && /OwnStore|Franchise|Outlet/i.test(b.storeType)) {
                return 1;
            }
            return a.distance < b.distance ? -1 : 1;
        }

        /**
         * @description Method to render google map marker for store
         * @param {Object} store store object
         * @param {String} store.id store id
         * @param {Number} store.lat latitude
         * @param {Number} store.lng longitude
         * @param {String} store.storeType store type
         * @returns {Boolean} true
         */
        function renderGoogleMapMarker(store) {
            var lat = Number(store.lat),
                lng = Number(store.lng),
                geoLocation = new $window.google.maps.LatLng(lat, lng),
                markerWidth = 32,
                markerHeight = 32,
                marker = new $window.google.maps.Marker({
                    'position': geoLocation,
                    'id' : store.id,
                    'storeType' : store.storeType,
                    'selected' : false,
                    'map': gmap,
                    'animation': $window.google.maps.Animation.DROP,
                    'icon': _markerIcon(store.storeType, markerWidth, markerHeight)
                });

            $window.google.maps.event.addListener(marker, 'click', function() {
                var searchResultsContainer = $('.jwsdw-storeFinder-verticalScroll'),
                    storeCard = $('.jwsdw-storeCard[data-store-id=' + this.id + ']:visible'),
                    storeId = this.id;

                selectStore(storeId);

                $scope.$apply(function() {
                    vm.selectedStore = vm.stores.find(function(str) {
                        return str.id === storeId;
                    });
                });
                if (vm.mapView && vm.viewport === 'small') {
                    setTimeout(function() {
                        storeCard = $('.jwsdw-storeCard:visible'),
                        $('html')[0].scrollTop = storeCard[0].getBoundingClientRect().top + document.documentElement.scrollTop - $('.jwsdw-header-module').height();
                    });
                } else {
                    _scrollToElement(searchResultsContainer[0], storeCard[0]);
                }
            });

            markers.push(marker);

            return marker;
        }

        /**
         * @description Method to clear markers on map
         * @returns {void}
         */
        function clearMarkers() {
            markers.forEach(function (marker) {
                marker.setMap(null);
            });
            markers = [];
        }

        /**
         * @description Method to get center coordinates of all stores
         * @param {Object[]} stores array of stores
         * @param {Number} stores[].lat latitude
         * @param {Number} stores[].lng longitude
         * @returns {Object} center coordinates
         */
        function _getCenter(stores) {
            var center = {'lat': 0, 'lng': 0};
            stores.forEach(function(store) {
                center.lat += Number(store.lat);
                center.lng += Number(store.lng);
            });

            center.lat /= stores.length;
            center.lng /= stores.length;

            return center;
        }

        /**
         * @description Method to open filter picker
         * @returns {void}
         */
        function openFilterPicker() {
            window.jwsdwMediator.publish('openPicker', 'filterPicker', vm);
        }

        /**
         * @description Method to apply filters
         * @param {Boolean} apply if true use scope apply function
         * @returns {void}
         */
        function applyFilters(apply) {
            if (apply) {
                $scope.$apply(filterStores);
            } else {
                filterStores();
            }
        }

        /**
         * @description Method to filter stores
         * @returns {void}
         */
        function filterStores() {
            _filter = [];

            Object.keys(vm.filter).forEach(function(filterId) {
                if (vm.filter[filterId]) {
                    _filter.push(filterId);
                }
            });

            if (_filter.length > 0) {
                $location.search('filter', _filter.join(','));
            } else {
                $location.search('filter', null);
            }

            vm.stores = _filterStores(_stores, vm.filter);

            if (vm.stores.length > 0) {
                vm.error = null;
            } else {
                vm.error = 'SEARCH_ERROR';
            }

            vm.filterCount = _filter.filter(function(filter) {
                return !/noJWStores|noRetailers|noOutlets/.test(filter);
            }).length;

            clearMarkers();

            vm.stores.forEach(function(store) {
                store && renderGoogleMapMarker(store);
            });
            if (vm.selectedPromos.length > 0) {
                consolidateMarkers();
            }
        }

        /**
         * @description Method to clear all filters
         * @param {Boolean} apply if true use scope apply function
         * @param {Boolean} preventUpdate if true, don't update UI
         * @returns {void}
         */
        function clearFilters(apply, preventUpdate) {
            vm.filter = $scope.filter = {};
            window.jwsdwMediator.publish('updatePicker', 'filterPicker', {
                'filter': vm.filter
            });

            if (!preventUpdate) {
                applyFilters(apply);
            }
        }

        /**
         * @description Method to check if extra filter has results
         * @param {String} filterId filter ID
         * @param {Boolean} [standAlone] if true, other filters are not considered
         * @returns {Boolean} true if results are available
         */
        function filterHasResults(filterId, standAlone) {
            var filter = standAlone ? {} : angular.extend({}, vm.filter),
                filteredStores;

            filter[filterId] = true;
            filteredStores = _filterStores(vm.stores, filter);

            return filteredStores.length > 0;
        }

        /**
         * @description Method to check if extra filter has results
         * @returns {Boolean} true if results can be filtered
         */
        function canBeFiltered() {
            var availableFilter = vm.services.filter(function(service) {
                return filterHasResults(service.id, true);
            });
            return availableFilter.length > 0;
        }

        /**
         * @description Method to resize map
         * @returns {void}
         */
        function resizeMap() {
            var center = gmap.getCenter();
            $window.google.maps.event.trigger(gmap, 'resize');
            gmap.setCenter(center);
        }

        /**
         * @description Method to generate Icon Object for given store type and size
         * @param {String} storeType store type
         * @param {Number} width width
         * @param {Number} height height
         * @returns {Object} icon object for google maps markers
         */
        function _markerIcon(storeType, width, height) {
            return {
                'url': 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(ICONS[storeType]),
                'scaledSize': new $window.google.maps.Size(width, height),
                'origin': new $window.google.maps.Point(0, 0),
                'anchor': new $window.google.maps.Point(width / 2, height)
            };
        }

        /**
         * @description Method to highlight store card and pin
         * @param {String} storeId store id
         * @returns {void}
         */
        function selectStore(storeId) {
            var storeCards = $('.jwsdw-storeCard'),
                storeCard = $('.jwsdw-storeCard[data-store-id=' + storeId + ']');

            markers.forEach(function(marker) {
                if (marker.id === storeId) {
                    marker.setIcon(_markerIcon(marker.storeType + '-selected', 64, 64));
                    marker.selected = true;
                    marker.setZIndex(9999);
                    gmap.setCenter(marker.position);
                } else if (marker.selected) {
                    marker.setIcon(_markerIcon(marker.storeType, 32, 32));
                    marker.selected = false;
                    marker.setZIndex(1);
                }
            });

            storeCards.removeClass('jwsdw-storeCard-active');
            storeCard.addClass('jwsdw-storeCard-active');
            vm.stores.forEach(function(store) {
                store.selected = store.id === storeId;
            });
        }
        /**
         * @description Method to highlight store card and pin
         * @param {String} storeId store id
         * @returns {void}
         */
        function highlightStore(storeId) {
            markers
                .filter(function(marker) {
                    return !marker.selected;
                })
                .forEach(function(marker) {
                    if (marker.id === storeId) {
                        marker.setIcon(_markerIcon(marker.storeType, 48, 48));
                        marker.highlighted = true;
                        marker.setZIndex(9999);
                    } else if (marker.highlighted) {
                        marker.setIcon(_markerIcon(marker.storeType, 32, 32));
                        marker.highlighted = false;
                        marker.setZIndex(1);
                    }
                });
        }

        /**
         * @description Method to scroll to storeCard
         * @param {Object} container DOM element
         * @param {Object} element DOM element
         * @returns {void}
         */
        function _scrollToElement(container, element) {
            container.scrollTop = element.offsetTop - 75;
        }

        /**
         * @description Method to scroll center of map
         * @returns {void}
         */
        function _centerViewportOnMap() {
            if (vm.mapView && vm.viewport === 'small') {
                $('html')[0].scrollTop = $map.getBoundingClientRect().top + ($map.clientHeight / 2) - (window.innerHeight / 2) + document.documentElement.scrollTop;
            }
        }

        /**
         * @description Method to filter array by given filters
         * @param {Object[]} stores array of store objects
         * @param {Object} filters filter object containing various custom filters
         * @returns {Object[]} array of stores
         * @private
         */
        function _filterStores(stores, filters) {
            vm.selectedPromos.forEach(function (promo) {
                filters[promo] = true;
            });

            Object.keys(filters).forEach(function(filter) {
                if (!filters[filter]) {
                    return;
                }
                if (filter === 'noJWStores') {
                    stores = stores.filter(function(store) {
                        return !/store|franchise/i.test(store.storeType);
                    });
                } else if (filter === 'noRetailers') {
                    stores = stores.filter(function(store) {
                        return !/retailer/i.test(store.storeType);
                    });
                } else if (filter === 'noOutlets') {
                    stores = stores.filter(function(store) {
                        return !/outlet/i.test(store.storeType);
                    });
                } else {
                    stores = stores.filter(function (store) {
                        var promoService = _promoServices.find(function(prmSrvc) {
                            return prmSrvc.id === filter;
                        });
                        if (!promoService) {
                            return false;
                        }
                        return promoService.participatingStores.indexOf(store.id) !== -1;
                    });
                }
            });

            return stores;
        }
    }
}(angular, jQuery));
